import { DetailBox } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';

type SectionDetailsProps = {
  sectionName?: string;
  courseName?: string;
  schoolName?: string;
  periodName?: string;
};

const SectionDetails = ({
  sectionName,
  courseName,
  schoolName,
  periodName,
}: SectionDetailsProps) => {
  const { t } = useTranslation(TranslationsKeys.CLASSES_BOOK_EDIT);

  return (
    <div className="d-flex w-100 justify-content-end">
      <div style={{ width: 'max-content' }}>
        <DetailBox
          columns={[
            {
              title: t('details.courseName'),
              body: courseName ?? 'N/D',
            },
            {
              title: t('details.sectionName'),
              body: sectionName ?? 'N/D',
            },
            {
              title: t('details.schoolName'),
              body: schoolName ?? 'N/D',
            },
            {
              title: t('details.periodName'),
              body: periodName ?? 'N/D',
            },
          ]}
        />
      </div>
    </div>
  );
};

export default SectionDetails;
